import { render, staticRenderFns } from "./teamLevelConfig.vue?vue&type=template&id=23a89f8d&scoped=true"
import script from "./teamLevelConfig.vue?vue&type=script&lang=js"
export * from "./teamLevelConfig.vue?vue&type=script&lang=js"
import style0 from "./teamLevelConfig.vue?vue&type=style&index=0&id=23a89f8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a89f8d",
  null
  
)

export default component.exports